import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./Mobile.css";

const Mobile = () => {
  return (
    <Container fluid style={{ marginTop: "160px" }}>
      <Card id="mobile-card">
        <Card.Body>
          <Row style={{ justifyContent: "center" }}>
            <Col xs={8} style={{ textAlign: "center" }}>
              <h1 id="mobile-header">PRAMS Mobile Applications</h1>
            </Col>
          </Row>
          <br />
          <Row style={{ justifyContent: "center" }}>
            <Col align="center" style={{ minWidth: "250px" }}>
              <h2 id="mobile-subheader">PRAMS Focus</h2>
              <p
                style={{
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: "bold",
                  fontSize: "18px",
                  paddingLeft: "35px",
                  paddingRight: "35px",
                }}
              >
                The PRAMS Focus inspection app allows for completion of various inspections allowing for the capture of a site image, time, and location information that can be included as part of the inspection to meet regulatory requirements.
              </p>
              <Button
                id="mobile-btn"
                href="https://apps.apple.com/us/app/prams-focus/id6473756942"
                target="_blank"
              >
                Download PRAMS Focus (iOS)
              </Button>
            </Col>
            <Col align="center" style={{ minWidth: "250px" }}>
              <h2 id="mobile-subheader">PRAMS X2M</h2>
              <p
                style={{
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: "bold",
                  fontSize: "18px",
                  paddingLeft: "35px",
                  paddingRight: "35px",
                }}
              >
                PRAMS Pumper X2M is a mobile application designed for
                efficient data entry in the field. Mimicking PumperX2, it allows users to quickly input and manage data. It allows the capability to work offline and sync data when a connection is available. 
              </p>
              <Button
                id="mobile-btn"
                href="https://apps.apple.com/us/app/pumper-x2m/id6756249475"
                target="_blank"
                style={{ marginRight: "10px" }}
              >
                Download PRAMS X2M (iOS)
              </Button>
              <Button
                id="mobile-btn"
                href="https://play.google.com/store/apps/details?id=com.pramsplus.pramsx2m&hl=en_US"
                target="_blank"
              >
                Download PRAMS X2M (Android)
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Mobile;